<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit general information</cll-dialog-title>
        <cll-dialog-subtitle>For {{ commissioner.reference }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="dialog-container-header">
            <cll-icon type="outlined" [size]="24">inventory_2</cll-icon>
            <span class="dialog-container-header-text">Commissioner details</span>
        </div>
        <div>
            <cll-form-field label="Reference">
                <input cllFormInput
                       [formControl]="commissionerDetailsFormGroup.controls.reference"
                       type="text">
            </cll-form-field>
        </div>
        <div>
            <cll-form-field label="Name">
                <input cllFormInput
                       [formControl]="commissionerDetailsFormGroup.controls.name"
                       type="text">
            </cll-form-field>
        </div>
        <div>
            <cll-slide-toggle
                class="p-0"
                [colour]="'secondary'"
                [formControl]="commissionerDetailsFormGroup.controls.mandatory_documents"
            >Send alert if packages are accepted without any documents attached</cll-slide-toggle>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (this.updateCommissionerRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="commissionerDetailsFormGroup.invalid || updateCommissionerRequest.loading()"
                (click)="update()">
            Save
        </button>

    </cll-dialog-footer>
</cll-dialog-layout>
